module.exports = __webpack_public_path__ + "static/media/trimex_fina_tacuarina.ba991d12.png";